import React from "react";
import { FunctionField, ReferenceField } from "react-admin";

import { translateApiProperty } from "@hisports/common";

export const MemberTypeField = ({ ...props }) => {
  return <ReferenceField basePath="/memberTypes" resource="memberTypes" reference="memberTypes" link={false} {...props}>
    <FunctionField source="name" render={memberType => {
      return translateApiProperty(memberType, 'name');
    }} />
  </ReferenceField>
};
